import React, { useEffect, useState } from "react";
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image";
import tboButton from '../../images/play-button-circled-v2.svg';
import '../../sass/components/flexibleModules/_components.videoGridSectionComponent.scss';

const VideoGridSectionComponent = ({ data }) => {

    useEffect(() => {
        var scriptOne = document.createElement('script');
        scriptOne.src = '//fast.wistia.com/embed/medias/z8fyt39293.jsonp';
        scriptOne.async = 'async';
        document.getElementsByTagName('head')[0].appendChild(scriptOne);
        var scriptTwo = document.createElement('script');
        scriptTwo.src = '//fast.wistia.com/assets/external/E-v1.js';
        scriptTwo.async = 'async';
        document.getElementsByTagName('head')[0].appendChild(scriptTwo);
    }, []);

    const [videoShow, setVideoShow] = useState(false);
    const [videoShowIndex, setVideoShowIndex] = useState(0);
    const showVideo = (val, index) => {
        setVideoShow(val);
        setVideoShowIndex(index);
    }

    return (
        <div className="cp-videoGridSection" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-videoGridSection__inner" style={{ maxWidth: `${data.maxWidth ? (data.maxWidth / 16 + "rem") : ""}`, margin: "0 auto" }}>
                <span className="l-absoluteIcon l-absoluteIcon1">
                    <StaticImage src="../../images/video-section-pattern1.svg" alt="pattern" />
                </span>
                <span className="l-absoluteIcon l-absoluteIcon2">
                    <StaticImage src="../../images/video-section-pattern2.svg" alt="pattern" />
                </span>
                <span className="l-absoluteIcon l-absoluteIcon3">
                    <StaticImage src="../../images/video-section-pattern3.svg" alt="pattern" />
                </span>
                {data.videoGridSectionHeader &&
                    <h2>{data.videoGridSectionHeader}</h2>
                }
                {data.videoGridSectionRepeater &&
                    <div data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease" className={`cp-videoGridSection__grid l--flex ${data.videoGridSectionRepeater.length === 1 ? "l-singleVideo" : "l-multipleVideos"}`}>
                        {data.videoGridSectionRepeater.map((videoSections, index) => (
                            <div className="cp-videoGridSection__grid-section" key={index} style={{ backgroundColor: `${videoSections.backgroundColor}` }}>
                                <div className="l--left">
                                    {videoSections.subHeader &&
                                        <span>{videoSections.subHeader}</span>
                                    }
                                    {videoSections.header &&
                                        <h2>{videoSections.header}</h2>
                                    }
                                    {videoSections.link &&
                                        <a className="l--flex" href={videoSections.link.url} target={videoSections.link.target}>
                                            <span>{videoSections.link.title}</span>
                                            <StaticImage src="../../images/arrow-right-white.svg" alt="" />
                                        </a>
                                    }
                                </div>
                                {videoSections.videoId &&
                                    <div className="l--right">
                                        <button onClick={() => showVideo(true, index)} className={`l--flex l--trig ${videoShow && videoShowIndex === index ? "l--buttonActive" : "l--buttonInactive"}`}>
                                            <div className="l-relative">
                                                {/* <span className="l-absolute"><StaticImage src="../../images/icon-play-new-black.svg" alt=""></StaticImage></span> */}
                                                <span className="l-absolute l--flex">
                                                    <img loading="lazy" src={tboButton} alt="" />
                                                    {process.env.GATSBY_LANG === "de" ?
                                                        <span>Video abspielen</span>
                                                        :
                                                        <span>Play Video</span>
                                                    }
                                                </span>
                                                {videoSections.videoThumbImage &&
                                                    <GatsbyImage image={getImage(videoSections.videoThumbImage.gatsbyImage)} alt={videoSections.videoThumbImage.altText} />
                                                }
                                            </div>
                                        </button>
                                        <div className={`l-embedWrap ${videoShow && videoShowIndex === index ? "l--active" : "l--notActive"}`}>
                                            <div className="l-embedWrap__inner">
                                                <div className={`wistia_embed wistia_async_${videoSections.videoId} autoPlay=true`}>&nbsp;</div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default VideoGridSectionComponent;